import { useRef, useEffect, useState, type ReactNode } from 'react';

interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  animation?: 'fade-in-up' | 'slide-in-left' | 'slide-in-right';
  delay?: number;
}

export default function SectionWrapper({
  children,
  className = '',
  animation = 'fade-in-up',
  delay = 0,
}: SectionWrapperProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const animationClass = visible ? `animate-${animation}` : 'opacity-0';

  return (
    <div
      ref={ref}
      className={`${className} ${animationClass}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}